<template>
  <button type="button" class="btn btn-sm" style="min-width: 160px;"
          :class="error ? 'btn-danger' : (copied ? 'btn-success' : 'btn-outline-primary')"
          @click="copy"
          :title="title">
    <span v-if="error"><span class="fas fa-exclamation-triangle me-1"></span> Copy failed</span>
    <span v-else-if="copied"><span class="fas fa-check me-1"></span> Copied</span>
    <span v-else><span class="fas fa-robot me-1"></span> Copy AI Prompt</span>
  </button>
</template>

<script>
export default {
  name: 'CopyAiPromptButton',
  props: {
    // The prompt text to copy. Pass a function if you want it computed lazily at click-time.
    prompt: {
      type: [String, Function],
      required: true
    },
    title: {
      type: String,
      default: 'Copy a ready-made prompt to help your AI set up the trading alerts for this Bot easily.'
    }
  },
  data () {
    return {
      copied: false,
      error: false,
      timer: null
    }
  },
  methods: {
    async copy () {
      const text = (typeof this.prompt === 'function') ? this.prompt() : this.prompt
      if (!text) return

      try {
        await navigator.clipboard.writeText(text)
        if (this.timer) clearTimeout(this.timer)
        this.error = false
        this.copied = true
        this.timer = setTimeout(() => { this.copied = false }, 2000)
      } catch (e) {
        console.error('Clipboard write failed:', e)
        if (this.timer) clearTimeout(this.timer)
        this.copied = false
        this.error = true
        this.timer = setTimeout(() => { this.error = false }, 3000)
      }
    }
  },
  beforeUnmount () {
    if (this.timer) clearTimeout(this.timer)
  }
}
</script>
